<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardBody>
                    <CForm>

                        <CRow>
                            <CCol class="h5">Подтверждение/Оформление</CCol>
                            <CInput
                                v-model="pushes.client_push_submited_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_submited"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">В работе</CCol>
                            <CInput
                                v-model="pushes.client_push_in_work_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_in_work"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Оплата</CCol>
                            <CInput
                                v-model="pushes.client_push_prepared_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_prepared"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Оплачен</CCol>
                            <CInput
                                v-model="pushes.client_push_paid_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_paid"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Собираем/Готовим</CCol>
                            <CInput
                                v-model="pushes.client_push_awaiting_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_awaiting"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Заказ готов</CCol>
                            <CInput
                                v-model="pushes.client_push_awaiting_ready_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_awaiting_ready"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_awaiting_ready_take_with_me"
                                class="w-100 ml-3"
                                label="Текст(Забрать с собой)"
                                horizontal
                            />

                        </CRow>
                        <CRow>
                            <CCol class="h5">Курьер</CCol>
                            <CInput
                                v-model="pushes.client_push_delivery_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_delivery"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                            <CInput
                                v-if="type === 'restaurant' && !allPushes"
                                v-model="pushes.client_push_delivery_met"
                                class="w-100 ml-3"
                                label="Текст (точка встречи)"
                                horizontal
                            />
                        </CRow>
                        <CRow v-if="allPushes">
                            <CCol class="h5">Курьер (точка встречи)</CCol>
                            <CInput
                                v-model="pushes.client_push_delivery_met_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_delivery_met"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Консьерж</CCol>
                            <CInput
                                v-model="pushes.client_push_delivery_concierge_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_delivery_concierge"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>

                        <CRow v-if="allPushes">
                            <CCol class="h5">Консьерж (точка встречи)</CCol>
                            <CInput
                                v-model="pushes.client_push_delivery_concierge_met_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_delivery_concierge_met"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Точка встречи</CCol>
                            <CInput
                                v-model="pushes.client_push_delivery_meeting_point_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_delivery_meeting_point"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Выполнен</CCol>
                            <CInput
                                v-model="pushes.client_push_done_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_done"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow v-if="allPushes">
                            <CCol class="h5">Выполнен (в точке встречи)</CCol>
                            <CInput
                                v-model="pushes.client_push_done_met_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_done_met"
                                class="w-100 ml-3"
                                label="Текст + в конце название башни"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Выполнен (оставили у двери)</CCol>
                            <CInput
                                v-model="pushes.client_push_done_door_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_done_door"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>
                        <CRow>
                            <CCol class="h5">Отменен</CCol>
                            <CInput
                                v-model="pushes.client_push_canceled_title"
                                class="w-100 ml-3"
                                label="Заголовок"
                                horizontal
                            />
                            <CInput
                                v-model="pushes.client_push_canceled"
                                class="w-100 ml-3"
                                label="Текст"
                                horizontal
                            />
                        </CRow>

                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="$emit('goBack')">Назад</CButton>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$emit('save', pushes)"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        name: 'EntityPushes',

        props: {
            entity: {
                type: Object,
                default: () => ({})
            },
            type: {
                type: String,
                default: ''
            },
            allPushes: {
                type: Boolean,
                default: false,
            }
        },

        data: () => ({
            pushes: {
                client_push_submited: '',
                client_push_submited_title: '',
                client_push_in_work: '',
                client_push_in_work_title: '',
                client_push_prepared: '',
                client_push_prepared_title: '',
                client_push_paid: '',
                client_push_paid_title: '',
                client_push_awaiting: '',
                client_push_awaiting_title: '',
                client_push_awaiting_ready: '',
                client_push_awaiting_ready_title: '',
                client_push_awaiting_ready_take_with_me: '',
                client_push_delivery: '',
                client_push_delivery_title: '',
                client_push_delivery_met: '',
                client_push_delivery_met_title: '',
                client_push_delivery_concierge: '',
                client_push_delivery_concierge_title: '',
                client_push_delivery_concierge_met: '',
                client_push_delivery_concierge_met_title: '',
                client_push_delivery_meeting_point: '',
                client_push_delivery_meeting_point_title: '',
                client_push_done: '',
                client_push_done_title: '',
                client_push_done_met: '',
                client_push_done_met_title: '',
                client_push_done_door: '',
                client_push_done_door_title: '',
                client_push_canceled: '',
                client_push_canceled_title: '',
            }
        }),

        computed: {},

        watch: {
            entity() {
                if (this.entity.pushes) {
                    this.pushes = this.entity.pushes;
                }
            }
        },

        mounted() {},

        methods: {},
    };
</script>
